import type { TagDTO } from '@invenco/sales-interface/interfaces';

import { Badge } from '@/components/core/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/core/tooltip';
import { truncateText } from '@/shared/helpers';

const MAX_TAG_NAME_LENGTH = 20;

function TagBadge({ name }: { name: string }) {
  if (name.length <= MAX_TAG_NAME_LENGTH) {
    return <Badge variant="secondary">{name}</Badge>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* tabIndex exposes the truncated badge's tooltip to keyboard users */}
        <Badge variant="secondary" tabIndex={0}>
          {truncateText(name, MAX_TAG_NAME_LENGTH)}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>{name}</TooltipContent>
    </Tooltip>
  );
}

export function OrderTags({ tags }: { tags: TagDTO[] }) {
  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((tag) => (
        <TagBadge key={tag.id} name={tag.name} />
      ))}
    </div>
  );
}
